window.addEventListener('DOMContentLoaded',()=>{
    let pageElements = {
        viewAllArticles : document.querySelector('[data-loadMoreArticles]') || undefined,
        paginationWrapper : document.querySelector('[data-paginate-container]') || undefined,
        blogContainer : document.querySelector('[data-article-list-container]') || undefined,
        nextPage : document.querySelector('[data-pagination][data-page-next]') || undefined,

    }

    function loadAllArticles() {
        if(pageElements.nextPage && pageElements.nextPage.dataset.href !='#'){
            let url = pageElements.nextPage.dataset.href;
            fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                const innerHTML = new DOMParser().parseFromString(html, 'text/html');
                let articles = innerHTML.querySelector('[data-article-list-container]').innerHTML;
                    pageElements.blogContainer.innerHTML +=articles;
                    pageElements.paginationWrapper.innerHTML = innerHTML.querySelector('[data-paginate-container]').innerHTML;
                    history.pushState({ url }, '', `${url}`);
                    pageElements.viewAllArticles = document.querySelector('[data-loadMoreArticles]') || undefined;
                    pageElements.nextPage = document.querySelector('[data-pagination][data-page-next]') || undefined;
                    if(pageElements.nextPage.dataset.href !='#'){
                        continueLoadMore();
                    }else{
                        pageElements.blogContainer.classList.remove('loadMore');
                    }
            })
            .catch((err)=>{
                console.log('failed to laod all articles');
                pageElements.paginationWrapper.classList.remove('d-none'); 
                pageElements.paginationWrapper.classList.add('d-md-flex');
            });
        }
    }

    function initBlogAjaxLoad() {
        if(pageElements.viewAllArticles){
            pageElements.viewAllArticles.addEventListener('click',(e)=>{
                e.target.closest('.blog-ewm')?.querySelector('.sidebar-blog').classList.remove('sticky-top');
            pageElements.blogContainer.classList.add('loadMore');
            e.preventDefault();
            e.stopImmediatePropagation();
                if(pageElements.paginationWrapper){
                    pageElements.paginationWrapper.classList.add('d-none'); 
                    pageElements.paginationWrapper.classList.remove('d-md-flex');
                    loadAllArticles();
                }
            });
        }
    }

    function continueLoadMore() {
        document.addEventListener('scroll', checkVisibilityOfElement);
    } 
     
    function checkVisibilityOfElement() {
        if(window.Utility.in_Viewport(pageElements.paginationWrapper)){
            loadAllArticles();
            document.removeEventListener('scroll', checkVisibilityOfElement);
        }
    }

    initBlogAjaxLoad(); 


    if (window.innerWidth < 992) {
        document.querySelectorAll('[data-artist-title]').forEach( x => {
            // x.addEventListener('click', (e) => {
            //     e.preventDefault();
            //     x.closest('[data-artist-wrap]').querySelector('[data-artist-body]').classList.toggle('d-none');
            // });
            x.querySelector('a').addEventListener('click', (e) => {
                e.preventDefault();
                if(x.closest('[data-artist-wrap]').classList.contains('open')){
                    Utility.toggleElement(x.closest('[data-artist-wrap]'), 'close');
                }else{
                    Utility.toggleElement(x.closest('[data-artist-wrap]'), 'open');
                }
            });
        });

        if(document.querySelector('[data-open-filter]') != null) {
            document.querySelector('[data-open-filter]').addEventListener('click', (e) => {
                e.preventDefault();
                siteOverlay.prototype.showOverlay();
                document.querySelector('[data-artist-filter]').classList.toggle('active');
            });
    
            document.querySelector('[data-close]').addEventListener('click', (e) => {
                e.preventDefault();
                siteOverlay.prototype.hideOverlay();
                document.querySelector('[data-artist-filter]').classList.remove('active');
            });
        }        

        if(document.querySelector('[data-category-bio]') != null) {
            document.querySelectorAll('[data-alpha]').forEach( x => {
                x.addEventListener('click',(e) => {
                    document.querySelectorAll('[data-alpha]').forEach( d => {
                        d.classList.remove('active');
                    });
                    e.currentTarget.classList.add('active');
                    document.querySelector('[data-no-letter]').classList.add('d-none');
                    let letter = e.target.getAttribute('data-alpha');
                    if(letter == '#'){
                        document.querySelectorAll('[data-letter]').forEach(y => {
                            y.classList.remove('d-none');
                        });
                    } else {
                        if(document.querySelectorAll(`[data-letter="${letter}"]`).length == 0){
                            document.querySelector('[data-no-letter]').classList.remove('d-none');
                            document.querySelectorAll('[data-letter]').forEach(y => {
                                y.classList.add('d-none');
                            });
                        } else {
                            document.querySelectorAll('[data-letter]').forEach(y => {
                                if(y.getAttribute('data-letter') != letter)
                                    y.classList.add('d-none');
                                else
                                    y.classList.remove('d-none');
                            });
                        }
                    }             
                });
            });
        }
        
    }


});


const blogSelectors = {
    pagination_value: document.querySelectorAll('[data-custom-pagination] .pagination_value'),
    yeargroups: document.querySelectorAll('[data-year-group]'),
    count: 0
};

class TemplateBlogArticleJS {
    constructor() {
        blogSelectors.pagination_value.forEach(input => input.addEventListener('change', this.updatePagination.bind(this)));

        if(blogSelectors.yeargroups != null){
            blogSelectors.yeargroups.forEach(year => {
                if(year.querySelector('[data-year-items]').innerHTML.length == 0){
                    year.classList.add('d-none');
                }
            });
        }
        
    }

    updatePagination(event){
        event.preventDefault();
        let _this = event.currentTarget;
        let currentvalue = document.querySelector('[data-custom-pagination] [type="radio"]:checked').value;        
        document.querySelector('[name="count"]').value = currentvalue;
        document.querySelector('[name="count"]').dispatchEvent(new Event('input', {
            bubbles: true,
            cancelable: true,
        }));

        let searchParams = `count=${currentvalue}`;
        document.querySelector('[data-article-lists]').classList.add('loading');

        const url = `${window.location.pathname}?${searchParams}`;        
        fetch(url)
        .then(response => response.text())
        .then((responseText) => {
            const html = responseText;
            this.renderAristGrid(html);
        });
        
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    renderAristGrid(html){
        const innerHTML = new DOMParser().parseFromString(html, 'text/html');
        const gridHTML = innerHTML.querySelector('[data-article-lists]').innerHTML;
        document.querySelector('[data-article-lists]').innerHTML = gridHTML;
        if(document.querySelectorAll('[data-year-group]') != null){
            document.querySelectorAll('[data-year-group]').forEach(year => {
                if(year.querySelector('[data-year-items]').innerHTML.length == 0){
                    year.classList.add('d-none');
                }
            });
        }
        this.updateEvents();
    }
    updateEvents(){
        let pagination_value = document.querySelectorAll('[data-custom-pagination] .pagination_value');
        pagination_value.forEach(input => input.addEventListener('change', this.updatePagination.bind(this)));
    }

}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();

